/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

const __vue_script__ = {
    name: 'BackstageIcons',

    components: { SearchBar },

    data() {
        return {
            icons: [],
            iconTab: 'legacy',
            loadingIcons: true,
            searchTerm: '',
            worker: null
        };
    },

    computed: {
        modernIcons() {
            return this.icons.filter(i => i.startsWith('ic-') && i.includes(this.searchTerm));
        },

        legacyIcons() {
            return this.icons.filter(i => i.startsWith('icon-') && i.includes(this.searchTerm));
        }
    },

    mounted() {
        this.initWorker();
        this.scanIcons();
    },

    beforeDestroy() {
        this.terminate();
    },

    methods: {
        initWorker() {
            try {
                console.info('[BackstageIcons] Initializing the worker');

                /** @type {WorkerOptions} */
                const workerOptions = {
                    name: 'spotme-css-icons-scanner'
                };

                this.worker = new Worker(`${window.BSTG.extLibs}/css-icons-scanner${window.BSTG.scriptSuffix}`, workerOptions);
                this.worker.onerror = event => console.error('[BackstageIcons] Could not initialize the worker.', event);
                this.worker.onmessage = this.handleWorkerMessage.bind(this);
            } catch (error) {
                console.error('[BackstageIcons] Workers not supported, can\'t proceed further');
            }
        },

        scanIcons() {
            const styleSheets = [];
            for (const sheet of document.styleSheets) {
                if (sheet.href === null) {
                    console.debug('[BackstageIcons] Skipping stylesheet as it is an inline element');
                    continue;
                }

                const cssRules = [];
                for (const rule of sheet.cssRules) {
                    cssRules.push({ selectorText: rule.selectorText });
                }
                styleSheets.push({ cssRules });
            }
            this.worker.postMessage({
                command: 'scan',
                styleSheets
            });
        },

        /**
         * @param {MessageEvent} event
         */
        handleWorkerMessage(event) {
            const response = event.data;
            if (response.type === 'icons') {
                console.info('[BackstageIcons] Icon scan completed');
                this.icons = Array.from(response[response.type]);
                this.loadingIcons = false;
            }
        },

        terminate() {
            console.info('[BackstageIcons] Terminating the worker');
            this.worker.postMessage({ command: 'kill' });
            this.worker.terminate();
            this.worker = null;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"backstage-icons in-page",attrs:{"status":_vm.loadingIcons}},[_c('header',[_c('search-bar',{attrs:{"showNoResult":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item",class:{ active: _vm.iconTab === 'legacy'}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.iconTab = 'legacy'}}},[_vm._v("Legacy")])]),_c('li',{staticClass:"nav-item",class:{ active: _vm.iconTab === 'modern'}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.iconTab = 'modern'}}},[_vm._v("Modern")])])])],1),(_vm.iconTab === 'legacy')?_c('div',{staticClass:"icons-list"},_vm._l((_vm.legacyIcons),function(icon,index){return _c('div',{key:(index + "-" + icon),staticClass:"box"},[_c('div',{staticClass:"type"},[_c('i',{class:icon})]),_c('div',{staticClass:"name"},[_c('code',[_vm._v("."+_vm._s(icon))])])])}),0):_vm._e(),(_vm.iconTab === 'modern')?_c('div',{staticClass:"icons-list"},_vm._l((_vm.modernIcons),function(icon,index){return _c('div',{key:(index + "-" + icon),staticClass:"box"},[_c('div',{staticClass:"type"},[_c('i',{class:icon})]),_c('div',{staticClass:"name"},[_c('code',[_vm._v("."+_vm._s(icon))])])])}),0):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BackstageIcons.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__